import { projectId, storage } from '../config/firebase';
import { deleteObject, ref, uploadBytes } from 'firebase/storage';

const storageUrl = projectId.includes('demo')
	? 'http://localhost:9199'
	: 'https://firebasestorage.googleapis.com';

export const getImageUrl = (name: string, size = 'full') => {
	let url = '';

	if (-1 !== name.search(/\.svg$/gi) || 'full' === size) {
		url = `${storageUrl}/v0/b/${projectId}.appspot.com/o/images%2F${name}?alt=media`;
	} else {
		const fileExtention = name.split('.').pop();
		const fileNameBody = name.replace(`.${fileExtention}`, '');

		url = `${storageUrl}/v0/b/${projectId}.appspot.com/o/images%2F${fileNameBody}@thumb-${size}.${fileExtention}?alt=media`;
	}

	return url;
};

export const getFileUrl = (name: string) => {
	return `${storageUrl}/v0/b/${projectId}.appspot.com/o/files%2F${name}?alt=media`;
};

export const get2xSize = (size: string) => {
	switch (size) {
		case 'full':
			return 'full';

		case 'thumbnail':
			return 'thumbnail';

		case 'medium':
			return 'mediumLarge';

		case 'mediumLarge':
			return 'large';

		case 'large':
			return 'wide';

		case 'wide':
			return 'wide';

		default:
			throw new Error(`Unknown image size: ${size}`);
	}
};

export const uploadImageToStorage = (fileName: string, file: File | Blob) => {
	const storageRef = ref(storage);

	const fileRef = ref(storageRef, `images/${fileName}`);

	return uploadBytes(fileRef, file, {
		cacheControl: 'public, max-age=31536000, s-maxage=31536000',
	});
};

export const removeImageFromStorage = (fileName: string) => {
	const storageRef = ref(storage);

	const fileRef = ref(storageRef, `images/${fileName}`);

	return deleteObject(fileRef);
};

export const uploadFileToStorage = (fileName: string, file: File) => {
	const storageRef = ref(storage);

	const fileRef = ref(storageRef, `files/${fileName}`);

	return uploadBytes(fileRef, file, {
		cacheControl: 'public, max-age=31536000, s-maxage=31536000',
	});
};

export const removeFileFromStorage = (fileName: string) => {
	const storageRef = ref(storage);

	const fileRef = ref(storageRef, `files/${fileName}`);

	return deleteObject(fileRef);
};

export const generateFileName = (name: string) => `${new Date().getTime()}_${name}`;
